module.exports = __webpack_public_path__ + "static/18-a7645a97284a42eb781ae53349a9cddb.jpg";